import { createContext, useContext } from 'react';

interface AuthContextType {
  user: null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
}

// Create a context with dummy values.
const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: false,
  signIn: async () => {
    // No-op sign in; you can extend this if needed.
  },
  signOut: async () => {
    // No-op sign out; you can extend this if needed.
  },
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  // Since you're not using Supabase for auth,
  // we simply return the context values directly.
  const value: AuthContextType = {
    user: null,
    loading: false,
    signIn: async (email: string, password: string) => {
      // Dummy implementation; you can add real logic here later if needed.
      console.log('Sign in attempted with', email, password);
    },
    signOut: async () => {
      // Dummy implementation.
      console.log('Sign out attempted');
    },
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
} 